import React, { memo, useContext, useEffect } from 'react';
import './sidebar.css';
import Logotipo from '../logotipo/logotipo';
import Navbar from 'react-bootstrap/Navbar';
import Select from 'react-select';
import NavbarDefault from './navbar';
import { Prefix } from '../../services/prefix';
import { Context } from '../../services/context';
import { useLocation } from 'react-router-dom';
import history from '../../services/history';
import { useFetch } from '../hooks/useFetch';
import { useWindowSize } from '@react-hook/window-size';

const Sidebar = () => {
  const context = useContext(Context);

  let group = Prefix.replace(/[\\"]/g, '');
  let location = useLocation();
  let pathname = location.pathname.split('/')[1];

  const listLicences = useFetch('/user');
  const licences = listLicences.data?.customer?.licenses;

  const options =
    group === 'customer'
      ? licences?.filter((fill) => fill.active === 1) || []
      : [
          { value: '1', label: 'GESTÃO', active: 1 },
          { value: '2', label: 'MONITORAMENTO', active: 1 },
        ];

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? '#5a1112' : '#333',
      padding: 5,
      paddingLeft: 15,
      background: '#fff',
      fontWeight: state.isSelected ? 'bold' : '',
    }),
  };

  function redirectApp(e) {
    if (group === 'admin' && e.label === 'GESTÃO') {
      history.push('/gestao/inicio');
    } else if (group === 'customer' && e.label === 'GESTÃO') {
      history.push('/gestao/cliente/inicio');
    } else if (e.label === 'MONITORAMENTO') {
      history.push('/monitoramento/inicio');
    } else if (e.label === 'PLANEJAMENTO') {
      history.push('/planejamento/inicio');
    } else {
      history.push('/');
    }
    window.location.reload();
  }

  const [width] = useWindowSize();

  useEffect(() => {
    width <= 768
      ? context.setIsActiveToggle(false)
      : context.setIsActiveToggle(true);
  }, [width]);

  function toggleSidebar() {
    context.setIsActiveToggle((prev) => !prev);
  }

  const valueSelected =
    pathname === 'gestao'
      ? options[0] || null
      : pathname === 'monitoramento'
      ? options[1] || null
      : options[1] || null;

  return (
    <>
      <Navbar
        id="sidebar"
        className={context.isActiveToggle ? 'active' : 'disabled'}
      >
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={toggleSidebar}
          className="text-white"
        />

        <div className="pl-4 pr-1">
          <div className="d-flex justify-content-center mb-2">
            {pathname === 'gestao' ? (
              <Logotipo
                src="../../media/logos/LOGO-GESTÃO-BRANCA.png"
                classe="fade-in mt_logo_sidebar img-fluid"
                alt="Logo DTLAB"
                width={180}
                height={180}
              />
            ) : (
              <Logotipo
                src="../../media/logos/logo-MTECH-monitoramento-BRANCO.png"
                classe="fade-in mt_logo_sidebar img-fluid"
                alt="Logo DTLAB"
                width={180}
                height={180}
              />
            )}
          </div>

          <div className="mb-4">
            {group !== 'tech' && (
              <Select
                styles={customStyles}
                options={options}
                value={valueSelected}
                placeholder="Escolher sistema..."
                onChange={redirectApp}
              />
            )}
          </div>

          <NavbarDefault />
        </div>
      </Navbar>

      <div className={`content ${context.isActiveToggle ? '' : 'collapsed'}`}>
      </div>
    </>
  );
};

export default memo(Sidebar);
